/**
 * [BLURY] | 🥭 ShapePanel
 * The shape layer: base palette, horizon band, global shape scale and opacity.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import { useStudio } from '@/state/useStudio';
import { Button, ButtonGroup } from '../ui/Button';
import { Section } from '../ui/Section';
import { Slider } from '../ui/Slider';
import { Swatch, SwatchRow } from '../ui/Swatch';
import { SelectedShapePanel } from './SelectedShapePanel';

export function ShapePanel() {
  const composition = useStudio(s => s.composition);
  const showHandles = useStudio(s => s.showHandles);
  const setNumeric = useStudio(s => s.setNumeric);
  const setColor = useStudio(s => s.setColor);
  const addShape = useStudio(s => s.addShape);
  const toggleHandles = useStudio(s => s.toggleHandles);
  const shuffle = useStudio(s => s.shuffle);

  return (
    <Section badge={1} title="Shape layer">
      <SwatchRow>
        <Swatch label="deep" value={composition.deep} onChange={v => setColor('deep', v)} />
        <Swatch label="cyan" value={composition.cyan} onChange={v => setColor('cyan', v)} />
        <Swatch label="pale" value={composition.pale} onChange={v => setColor('pale', v)} />
      </SwatchRow>

      <div style={{ marginTop: 14 }}>
        <Slider
          label="horizon"
          value={composition.horizon}
          min={0}
          max={100}
          format={v => `${v}%`}
          onChange={v => setNumeric('horizon', v)}
        />
        <Slider
          label="horizon softness"
          value={composition.hsoft}
          min={1}
          max={100}
          format={v => `${v}%`}
          onChange={v => setNumeric('hsoft', v)}
        />
        <Slider
          label="shape scale"
          value={composition.scale}
          min={20}
          max={220}
          format={v => `${(v / 100).toFixed(2)}×`}
          onChange={v => setNumeric('scale', v)}
        />
        <Slider
          label="shape opacity"
          value={composition.opacity}
          min={0}
          max={100}
          format={v => `${v}%`}
          onChange={v => setNumeric('opacity', v)}
        />
      </div>

      <SelectedShapePanel />

      <div style={{ marginTop: 12 }}>
        <ButtonGroup>
          <Button onClick={() => addShape()}>+ shape</Button>
          <Button active={showHandles} onClick={toggleHandles}>
            handles
          </Button>
          <Button onClick={shuffle}>shuffle</Button>
        </ButtonGroup>
      </div>
    </Section>
  );
}
